import SearchOrigin from '@alltrails/amplitude/enums/SearchOrigin';
import SearchResultSelectionMethod from '@alltrails/amplitude/enums/SearchResultSelectionMethod';
import SearchSuggestionSelectionType from '@alltrails/amplitude/enums/SearchSuggestionSelectionType';
import { resetState } from '@alltrails/explore-service/redux/exploreServiceSlice';
import { AppDispatch } from '@/utils/redux';

export default function handleNaturalLanguageResultSelect(
  dispatch: AppDispatch,
  query: string,
  clickPosition: number,
  selectionType: SearchSuggestionSelectionType,
  selectionMethod?: SearchResultSelectionMethod,
  searchOrigin?: SearchOrigin
) {
  dispatch(
    resetState({
      persistKeys: ['boundingBox', 'mapRotation', 'sort', 'userLocation'],
      initialState: {
        exploreActionType: 'search result clicked',
        naturalLanguageQuery: query,
        naturalLanguageSearchAnalyticData: {
          clickPosition,
          queryText: query,
          selectionType,
          selectionMethod,
          searchOrigin
        }
      }
    })
  );
}
